import * as DateUtil from "@eres/core/dist/DateTime";
import { TenancyContract, Tenant, TenantRegiModel, TenantTerminateRequest } from "./Entity/tenant";
import { Contract, ContractComputeRequest } from "./Entity/contract";
import { normalizeEntityNumber } from "./Utils";
import { ServerDate } from "@eres/core";

export function normalizeContractComputeRequest( request: ContractComputeRequest ) {
	normalizeEntityNumber( request, "ContractValue" );
	normalizeEntityNumber( request, "DiscountValue" );
	if ( request.AssociatedContractAnnualCosts ) {
		for ( const ac of request.AssociatedContractAnnualCosts ) {
			normalizeEntityNumber( ac, "Value" );
			normalizeEntityNumber( ac, "DiscountValue" );
		}
	}
}

export function toEjariData( input: Date | ServerDate ): ServerDate {
	if ( input == undefined ) return undefined!;
	if ( !( input instanceof Date ) )
		input = input.asDate();
	return DateUtil.formatDate( input, "MM-DD-YYYY", "en" );
}

function convertToEjariDate<T>( source: T, ...keys: ( keyof T )[] ): object {
	return keys.reduce( ( previousValue, currentValue ) => {
		let value = source[ currentValue ];
		if ( value != undefined ) {
			previousValue[ currentValue + "" ] = toEjariData( value as any );
		}
		return previousValue;
	}, {} as any );
}

export function normalizeContract( contract: Contract ): Contract {
	contract = {
		...contract,
		...convertToEjariDate( contract, "ContractEndDate", "ContractStartDate", "GraceEndDate", "GraceStartDate" ),
	};
	if ( contract.PaymentPlan != undefined && contract.PaymentPlan.length > 0 ) {
		contract.PaymentPlan = contract.PaymentPlan.map( value => {
			return {
				...value,
				InstallmentDueDate: toEjariData( value.InstallmentDueDate! ),
				PaymentType: value.PaymentTypeId,
			};
		} );
	}
	if ( contract.AssociatedContractAnnualCosts != undefined && contract.AssociatedContractAnnualCosts.length > 0 ) {
		contract.AssociatedContractAnnualCosts = contract.AssociatedContractAnnualCosts.map( value => {
			return {
				...value,
				StartDate: toEjariData( value.StartDate! ),
				EndDate: toEjariData( value.EndDate! ),
			};
		} );
	}
	if ( contract.Tenants != undefined && contract.Tenants.length > 0 ) {
		contract.Tenants = contract.Tenants.map( tenant => {
			if ( tenant.Person != undefined ) {
				tenant.Person = {
					...tenant.Person,
					...convertToEjariDate( tenant.Person, "DOB", "PassportExpiryDate", "PassportIssueDate", "VisaExpiryDate",
						"VisaStartDate" ),
				};
			}
			if ( tenant.Company != undefined ) {
				tenant.Company = {
					...tenant.Company,
					...convertToEjariDate( tenant.Company, "LicenseExpiryDate", "LicenseIssueDate" ),
				};
			}
			return tenant;
		} );
	}
	return contract;
}

export function normalizeTenantContract( contract: TenancyContract ): TenancyContract {
	contract = {
		...contract,
		...convertToEjariDate( contract, "ContractEndDate", "ContractStartDate", "GraceEndDate", "GraceStartDate" ),
	};
	if ( contract.Tenants != undefined && contract.Tenants.length > 0 ) {
		contract.Tenants = contract.Tenants.map( ( tenant: Tenant ) => {
			if ( tenant.Person != undefined ) {
				tenant.Person = {
					...tenant.Person,
					...convertToEjariDate( tenant.Person, "DOB", "PassportExpiryDate", "PassportIssueDate", "VisaExpiryDate",
						"VisaStartDate" ),
				};
			}
			return tenant;
		} );
	}
	return contract;
}

export function normalizeTenantRegistration( contract: TenantRegiModel ): TenantRegiModel {
	contract = {
		...contract,
		...convertToEjariDate( contract, "BirthDate", "PassportIssueDate", "PassportExpiryDate", "VisaIssueDate", "VisaExpiryDate" ),
	};
	return contract;
}

export function normalizeTenantTerminate( contract: TenantTerminateRequest ): TenantTerminateRequest {
	contract = {
		...contract,
		...convertToEjariDate( contract, "TerminationDate" ),
	};
	return contract;
}
